import React, { useEffect, useState } from "react";
import { Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import BootstrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  sortCaret,
  headerSortingClasses,
  PleaseWaitMessage,
  NoRecordsFoundMessage,
} from "../../../_metronic/_helpers";
import { useDispatch, useSelector } from "react-redux";

import { useHistory } from "react-router-dom";
import {
  sizePerPageList,
  showSuccessDialog,
  showErrorDialog,
  activeFormatter,
  showConfirmDialog,
  formatDate,
  lockedFormatter,
  showDeleteDialog,
  checkPermision,
  formLabelsTheme,
} from "../../utility";
import { toAbsoluteUrl } from "../../../_metronic/_helpers";
import SVG from "react-inlinesvg";
import { Button, Col, Row } from "react-bootstrap";
import LoadingFetchData from "../../utility/LoadingFetchData";
import { FormHelperText } from "@material-ui/core";
import {
  editMstareatype,
  removeMstareatype,
  selectPermissionAreaType,
} from "./motorPoolSlice";

// MUI
import {
  fade,
  withStyles,
  makeStyles,
  createMuiTheme,
  ThemeProvider,
} from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";

import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  selectAreaFunc,
  selectParameter,
} from "../businessParameter/businessParameterSlice";
import { Autocomplete } from "@material-ui/lab";

const useStylesReddit = makeStyles((theme) => ({
  root: {
    border: "1px solid #e2e2e1",
    overflow: "hidden",
    borderRadius: 4,
    backgroundColor: "#FFFFFF",
    transition: theme.transitions.create(["border-color", "box-shadow"]),
    "&:hover": {
      backgroundColor: "#fff",
    },
    "&$focused": {
      backgroundColor: "#fff",
      boxShadow: `${fade(theme.palette.primary.main, 0.25)} 0 0 0 2px`,
      borderColor: theme.palette.primary.main,
    },
  },
  focused: {},
}));

function RedditTextField(props) {
  const classes = useStylesReddit();

  return (
    <TextField InputProps={{ classes, disableUnderline: true }} {...props} />
  );
}
const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flexWrap: "wrap",
  },
  margin: {
    margin: theme.spacing(1),
  },
}));

export const AreaTypeTable = ({
  data,
  page,
  sizePerPage,
  sortField,
  sortOrder,
  onTableChange,
  totalSize,
  loading,
  handleSearch,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const classes = useStyles();
  const dataArea = useSelector(selectAreaFunc);
  const permission = useSelector(selectPermissionAreaType);

  useEffect(() => {
    const initData = data.map((item, index) => {
      return {
        ...item,
        no: index + 1,
      };
    });
    setTableData(initData);
  }, [data, sizePerPage, page]);

  const [tableData, setTableData] = useState(data);
  const [idRow, setIdRow] = useState("");

  const handleDelete = async (e, row) => {
    const params = { areatype_id: `${row.areatype_id}` };
    const action = await showDeleteDialog(`Are you sure you want to delete?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(removeMstareatype({ data: params }));
        if (response.payload.data.status === 200) {
          const action = await showSuccessDialog(response.payload.data.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const actionFormatter = (e, row, rowIndex) => {
    return (
      <>
        <div>
          {/* <OverlayTrigger
            overlay={<Tooltip id="products-edit-tooltip">View</Tooltip>}
          >
            <a
              className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3 mb-1"
              onClick={() => {
                history.push(
                  `/administration/management-user/view/${row.emp_id}`,
                  { userName: row.username }
                );
              }}
            >
              <span className="svg-icon svg-icon-md svg-icon-light">
                <SVG
                  src={toAbsoluteUrl( "/media/svg/icons/New/Search.svg")}
                />
              </span>
            </a>
          </OverlayTrigger> */}
          {checkPermision(permission, "UPDATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={<Tooltip id="products-edit-tooltip">Edit</Tooltip>}
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => {
                      setIdRow(row.areatype_id);
                      setFormValues({
                        areatype_code: {
                          value: row.areatype_code,
                          error: false,
                          required: "Y",
                        },
                        areatype_description: {
                          value: row.areatype_description,
                          error: false,
                          required: "Y",
                        },
                        area_function: {
                          value: row.area_function,
                          error: false,
                          required: "Y",
                        },
                      });
                      handleShow();
                    }}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/edit.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "DELETE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-delete-tooltip">Delete</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={(e) => handleDelete(e, row)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/delete.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}

          {checkPermision(permission, "UPDATE") && (
            <>
              {row.is_enable === "Y" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Disabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleDisabled(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-light">
                      <SVG
                        src={toAbsoluteUrl(
                          "/media/svg/icons/New/eye-slash.svg"
                        )}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
              {row.is_enable === "N" && (
                <OverlayTrigger
                  overlay={
                    <Tooltip id="products-edit-tooltip">Enabled</Tooltip>
                  }
                >
                  <div
                    className="btn btn-icon btn-primary btn-hover-primary btn-sm mr-3"
                    onClick={() => handleEnable(e, row, rowIndex)}
                  >
                    <span className="svg-icon svg-icon-md svg-icon-primary">
                      <SVG
                        src={toAbsoluteUrl("/media/svg/icons/New/eye.svg")}
                      />
                    </span>
                  </div>
                </OverlayTrigger>
              )}
            </>
          )}
        </div>
      </>
    );
  };
  const columns = [
    {
      text: "No",
      dataField: "no",
      // sort: true,
      // sortCaret: sortCaret,
      // headerSortingClasses,
      style: { width: "40px" },
      headerAlign: "center",
    },
    {
      text: "Code",
      dataField: "areatype_code",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Description",
      dataField: "areatype_description",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      text: "Area Function",
      dataField: "area_function_name",
      sort: true,
      sortCaret: sortCaret,
      headerSortingClasses,
      headerAlign: "center",
    },
    {
      dataField: "actions",
      text: "Actions",
      formatter: actionFormatter,
      align: "center",
      headerAlign: "center",
    },
  ];

  const options = {
    page: page < 0 ? 1 : page,
    sizePerPage: sizePerPage,
    showTotal: true,
    totalSize: totalSize,
    sizePerPageList: sizePerPageList(totalSize),
  };

  const handleDisabled = async (e, row, rowIndex) => {
    const params = {
      areatype_id: row.areatype_id,
      is_enable: "N",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to Disabled ?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editMstareatype(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };
  const handleEnable = async (e, row, rowIndex) => {
    const params = {
      areatype_id: row.areatype_id,
      is_enable: "Y",
    };
    console.log(params);

    const action = await showConfirmDialog(`Are you sure want to Enabled ?`);
    if (action.isConfirmed) {
      try {
        const response = await dispatch(editMstareatype(params));
        if (response.payload.status === 200) {
          const action = await showSuccessDialog(response.payload.message);
          await handleSearch();
        } else {
          showErrorDialog(response.payload.data.message);
        }
      } catch (error) {
        console.log(error);
      }
    }
  };

  const icon = <SVG src={toAbsoluteUrl("/media/svg/icons/New/x-error.svg")} />;

  // edit
  const [show, setShow] = useState(false);

  const handleClose = () => {
    setFormValues({
      areatype_code: {
        value: "",
        error: false,
        required: "Y",
      },
      areatype_description: {
        value: "",
        error: false,
        required: "N",
      },
      area_function: {
        value: "",
        error: false,
        required: "Y",
      },
    });
    setShow(false);
  };
  const handleShow = () => setShow(true);

  const [formValues, setFormValues] = useState({
    areatype_code: {
      value: "",
      error: false,
      required: "Y",
    },
    areatype_description: {
      value: "",
      error: false,
      required: "N",
    },
    area_function: {
      value: "",
      error: false,
      required: "Y",
    },
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormValues({
      ...formValues,
      [name]: {
        ...formValues[name],
        value,
      },
    });
  };

  const validatePost = (e) => {
    let isValid = true;

    const formFields = Object.keys(formValues);
    let newFormValues = { ...formValues };

    for (let index = 0; index < formFields.length; index++) {
      const currentField = formFields[index];
      const currentValue = formValues[currentField].value;
      const required = formValues[currentField].required;

      if (currentValue === "" && required === "Y") {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: true,
          },
        };
        isValid = false;
      } else {
        newFormValues = {
          ...newFormValues,
          [currentField]: {
            ...newFormValues[currentField],
            error: false,
          },
        };
      }
    }

    setFormValues(newFormValues);

    console.log(isValid, "isValid");
    return isValid;
  };

  const handleSave = async () => {
    if (!validatePost()) {
      return;
    }

    const params = {
      areatype_id: idRow,
      areatype_code: formValues.areatype_code.value,
      areatype_description: formValues.areatype_description.value,
      area_function: formValues.area_function.value,
    };

    console.log(params, "params");

    try {
      const response = await dispatch(editMstareatype(params));

      if (response.payload.status === 200) {
        const action = await showSuccessDialog(response.payload.data.message);
        await handleSearch();
      } else {
        await showErrorDialog(response.payload.data.message);
      }
    } catch (error) {
      showErrorDialog(error.message);
    }
  };

  const areaOptions = dataArea.map((e) => {
    return {
      value: e.param_code,
      label: e.param_value,
    };
  });

  const index = areaOptions.findIndex(
    (obj) => obj.value === formValues.area_function.value
  );

  const handleChangeArea = (e, params) => {
    const value = params.value;
    setFormValues({
      ...formValues,
      ["area_function"]: {
        ...formValues["area_function"],
        value,
      },
    });
  };

  return (
    <>
      <BootstrapTable
        remote
        wrapperClasses="table-responsive"
        classes="table table-head-custom table-vertical-center overflow-hidden rounded mt-4"
        bootstrap4
        
        keyField="areatype_id"
        data={tableData}
        columns={columns}
        pagination={paginationFactory(options)}
        onTableChange={onTableChange}
        sort={{ dataField: sortField, order: sortOrder }}
        hover
        striped
      >
        <PleaseWaitMessage entities={loading ? null : tableData} />
        <NoRecordsFoundMessage entities={loading ? null : tableData} />
      </BootstrapTable>
      {/* Footer */}

      {/* Modal Create */}
      <Modal
        size="xl"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        show={show}
        onHide={handleClose}
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter text-white">
            Edit Area Type
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <ThemeProvider theme={formLabelsTheme}>
            <div>
              <Row>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {" "}
                  <RedditTextField
                    required
                    label="Code"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="areatype_code"
                    value={formValues.areatype_code.value}
                    onChange={handleChange}
                    error={formValues.areatype_code.error}
                    helperText={
                      formValues.areatype_code.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {icon} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />
                  <Autocomplete
                    disablePortal
                    name="area_function"
                    options={areaOptions}
                    getOptionLabel={(option) => option.label.toString()}
                    disableClearable={true}
                    onChange={handleChangeArea}
                    value={areaOptions[index]}
                    renderInput={(params) => (
                      <RedditTextField
                        className={classes.margin}
                        {...params}
                        required
                        label="Area Function "
                        id="reddit-input"
                        size="small"
                        fullWidth
                        placeholder="Select Area"
                        name="area_function"
                        helperText={
                          formValues.area_function.error ? (
                            <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                              {icon} {"This field is required"}
                            </FormHelperText>
                          ) : (
                            ""
                          )
                        }
                      />
                    )}
                  />
                </Col>
                <Col xs={12} sm={3} md={6} lg={6}>
                  {" "}
                  <RedditTextField
                    label="Description"
                    className={classes.margin}
                    variant="filled"
                    id="reddit-input"
                    size="small"
                    fullWidth
                    name="areatype_description"
                    value={formValues.areatype_description.value}
                    onChange={handleChange}
                    error={formValues.areatype_description.error}
                    helperText={
                      formValues.areatype_description.error ? (
                        <FormHelperText sx={{ mt: "5px", mb: "-10px" }}>
                          {icon} {"This field is required"}
                        </FormHelperText>
                      ) : (
                        ""
                      )
                    }
                  />{" "}
                </Col>
              </Row>
            </div>
          </ThemeProvider>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={handleClose}>
            Close
          </Button>
          <Button variant="primary" onClick={handleSave}>
            Save
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};
